import React from "react";
import { connect } from "react-redux";
import { callService} from "../tools";
import { fnToSlash, formatDateDMA, fnMoneda } from "../tools";
const mapState = (state) => {
	return {
		"poliza": state.polizas.poliza
	};
};

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({ "type": "LOADER", "show": show });
		}
	};
};

class CobranzaPoliza extends React.Component {
	nuevoObjetoCobranza = null;

	state = {
		muestraHTML : false
	}

	componentWillMount = () => {
		this.props.loader(true);
		const dataInfo = {
			"poliza": this.props.poliza.generales.numPoliza,
			"fechaIni": this.props.poliza.generales.fchVigenciaInicial.split("/")[2] + 
			"-" + this.props.poliza.generales.fchVigenciaInicial.split("/")[1] + "-" + 
			this.props.poliza.generales.fchVigenciaInicial.split("/")[0],
			"fechaFin": this.props.poliza.generales.fchVigenciaFinal.split("/")[2] + 
			"-" + this.props.poliza.generales.fchVigenciaFinal.split("/")[1] + "-" + 
			this.props.poliza.generales.fchVigenciaFinal.split("/")[0],
		}
		new callService({
			service: "recibos.consultar",
			"secure": true,
			data: dataInfo
		}).execute().then(oResultado => {
			const cobranzaNodo = {
				"cobranza": oResultado
			}
			this.nuevoObjetoCobranza = Object.assign({} ,this.props.poliza, cobranzaNodo );
		
			this.setState({ muestraHTML: true })
			this.render();
			this.props.loader(false);
		});
	}

	validacionImagenesRamo = (ramo) => {
		if(ramo === 'A') {
			return require("../img/circle-cobranza.svg");
		}else if(ramo === 'G') {
			return require("../img/circle-cobranza.svg");
		}else if(ramo === 'D') {
			return require("../img/circle-cobranza.svg");
		}else if(ramo === 'V') {
			return require("../img/circle-cobranza.svg");
		}else {
			return "";
		}
	}

	validacionRecibosCobranza= () => {
		if (this.props.poliza.cobranza && this.props.poliza.cobranza.registros && this.props.poliza.cobranza.registros.length > 0) {
			const aRecibos = this.props.poliza.cobranza.registros.sort(
				function(a,b){ 
					return b.codNumRecibo.localeCompare(a.codNumRecibo)
				});
			return aRecibos[aRecibos.length - 1];
		}else if(this.nuevoObjetoCobranza!== null && this.nuevoObjetoCobranza.cobranza.registros && this.nuevoObjetoCobranza.cobranza.registros.length > 0 ) {
			const aRecibos = this.nuevoObjetoCobranza.cobranza.registros.sort(
				function(a,b){ 
					return b.codNumRecibo.localeCompare(a.codNumRecibo)
				});
			return aRecibos[aRecibos.length - 1];
		}else {
			console.log('ocurrio un error');
			return  "";
		}
	}

	formatPagadoFuncion = (pagado,cobranza) => {
		if(pagado){
			return formatDateDMA(cobranza.fechaVencRec);
		}else {
			return formatDateDMA(cobranza.fechaEfecRec);
		}
	} 

	conductoCobroFuncion  = (cobranza) => {
		if(cobranza.cveCanalCobro === "IN"){
			return "Asesor Profesional de seguros"
		}else {
			return "BANCO"
		}
	}

	monedaFuncion = (cobranza) => {
		if( cobranza.cveCodMoneda === "MXP" ) {
			return "Nacional";
		}else {
			return "Dolares";
		}
	}

	render() {
		let cobranza = null;
		let pagado = false;

		cobranza = this.validacionRecibosCobranza();

		if(this.props.poliza.cobranza){
			if (this.props.poliza.cobranza && cobranza == null && this.props.poliza.cobranza.pagado && this.props.poliza.cobranza.pagado.length) {
				cobranza = this.props.poliza.cobranza.pagado[0];
				pagado = true;
			}
		}

		return (
			<div>
			{this.state.muestraHTML ? 
				<div className="card">
				<i>
				<img src={this.validacionImagenesRamo(this.props.poliza.generales.cveRamo) } alt="" className="pad-right-10" />
				</i>
				<span className="blue-text detalle-seccion">Cobranza</span>
				<ul className="list-divider mt-25">
					<li className="clearfix">
						<div className="pull-left">
							<p><b>Pagado hasta</b></p>
						</div>
						<div className="pull-right">
							<div className="gray-text texto15">
								<p name="pagadoHasta">{ this.formatPagadoFuncion(pagado,cobranza) }</p>
							</div>
						</div>
					</li>
					<li className="clearfix">
						<div className="pull-left">
							<p><b>Forma de pago</b></p>
						</div>
						<div className="pull-right">
							<div className="gray-text texto15">
								<p name="formaPago">{ this.props.poliza.generales.formaPago }</p>
							</div>
						</div>
					</li>
					<li className="clearfix">
						<div className="pull-left">
							<p><b>Importe total a pagar</b></p>
						</div>
						<div className="pull-right">
							<div className="gray-text texto15">
								<p name="totalPagar">$ { fnMoneda(cobranza.impTotalRecibo) }</p>
							</div>
						</div>
					</li>
					<li className="clearfix">
						<div className="pull-left">
							<p><b>Fecha de último pago</b></p>
						</div>
						<div className="pull-right">
							<div className="gray-text texto15">
								<p name="fechaUltimoPago">{ fnToSlash(this.props.poliza.generales.fechaUltPago) }</p>
							</div>
						</div>
					</li>
					<li className="clearfix">
						<div className="pull-left">
							<p><b>Conducto de cobro</b></p>
						</div>
						<div className="pull-right">
							<div className="gray-text texto15">
								<p name="conductoCobro">{ this.conductoCobroFuncion(cobranza) }</p>
							</div>
						</div>
					</li>
					<li className="clearfix">
						<div className="pull-left">
							<p><b>Moneda</b></p>
						</div>
						<div className="pull-right">
							<div className="gray-text texto15">
								<p name="moneda">{ this.monedaFuncion(cobranza)}</p>
							</div>
						</div>
					</li>
				</ul>
			</div> : null }
		</div>);
		
	}
}

export default connect(mapState, mapDispatch)(CobranzaPoliza);



// WEBPACK FOOTER //
// ./src/home/cobranza.cmpt.js